$(function(){
　var state = false;
　$('.hamburger').click(function(){
　　if (state == false) {
　　　$('body').addClass('overflow-hidden');
　　　state = true;
　　} else {
　　　$('body').removeClass('overflow-hidden');
　　　state = false;
　　}
　});
  
  $('.product-swatch').click(function(){
    var param = location.search;
    param = param.replace("?variant=", "");
    for (i = 1; i < 100; i++) {
      var elem = document.getElementById('disp-'+i);
      if (elem) {
        var value = elem.getAttribute('value');
        if (param == value) {
          elem.style.display ="block";
        } else {
          elem.style.display ="none";
        }
      } else {
        continue;
      }
    }
　});
  
  $('.product-swatch').on('inview', function() {
    var param = location.search;
    param = param.replace("?variant=", "");
    for (i = 1; i < 100; i++) {
      var elem = document.getElementById('disp-'+i);
      if (elem) {
        var value = elem.getAttribute('value');
        if (param == value) {
          elem.style.display ="block";
        } else {
          elem.style.display ="none";
        }
      } else {
        continue;
      }
    }
  });
  
  $('.type--smaller').on('inview', function() {
    $('p:contains("variant_id")').remove();
    $("[id=cart-items-info]").removeAttr('hidden');
  });

  $('.product--cnt').on('inview', function() {
    var elems = $("[id=product-cnt]");
    for(var elem of elems) {
      if ($(elem).text() == 'ギフトラッピング' || $(elem).text() == 'ギフトメッセージ' || $(elem).text() == 'のし') {
        $(elem).parent().parent().next().remove();
        // $(elem).parent().parent().next().css('display', '');
      } else {
        $(elem).parent().parent().next().css('display', '');
      }
    }
  });
});